import pre from './pre';
import cart from './cart.vue';
import config from './config/index.vue';
import success from './success.vue';
export default {
  pre,
  components: {
    config,
    cart,
    success
  },
};
